export default __webpack_public_path__ + "static/media/lg-s.59fdba33.png";